export enum PageType {
  ACTIVITIES = 'Activities Page',
  AIRBNB = 'Airbnb Page',
  AUTH = 'Auth Page',
  BOOKING = 'Booking Page',
  BOOKING_CANCELLATION = 'Booking Cancellation Page',
  BOOKING_CONFIRMATION = 'Booking Confirmation Page',
  BOOKING_DETAILS = 'Booking Details Page',
  CAMPAIGNS = 'Campaigns Page',
  CHANGE_DATES = 'Change Dates Page',
  CHANGE_DATE_REQUEST = 'Change Date Request Page',
  CONTACT_US = 'Contact Us Page',
  DEALS = 'Deals Page',
  DESTINATION = 'Destination Page',
  EMAIL_US_FORM = 'Email Us Form Page',
  EXCLUSIVE_OFFER = 'Exclusive Offer Page',
  FAQS = 'FAQs Page',
  FIND_BOOKING = 'Find Booking Page',
  HOME = 'Home Page',
  LATEST_BOOKINGS = 'Latest Bookings Page',
  LOGIN = 'Login Page',
  LOGIN_REDIRECTION = 'Login Redirection Page',
  LOGOUT = 'Logout Page',
  MAP = 'Map Page',
  MY_BOOKINGS = 'My Bookings Page',
  PRINT_BOOKING_DETAILS = 'Print Booking Details Page',
  PROPERTY = 'Property Page',
  SEARCH = 'Search Page',
  UNKNOWN = 'Unknown Page',
}
